import { FC, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { merge, pick } from "lodash-es";

import { editCurrentUser } from "Auth/state";
import { AUTH_ACTIONS } from "Auth/types";
import { useStateActionMeta } from "Auth/utils";
import { UserBodyPreferencesForm } from "Bands/components";
import { IBandUserBodyPreferences, UserBooleanAttribute } from "Bands/types";
import { useProfileContext } from "Auth/contexts";
import { useIsUserPreferenceFormSubmitted } from "Bands/utils";
import { IAPIState } from "shared/types";

interface Props {
  handleClose: () => void;
}

export const EditUserBodyPreferencesForm: FC<Props> = ({ handleClose }) => {
  const dispatch = useDispatch();

  const { userAttributes } = useProfileContext();

  const { status, error } = useStateActionMeta(AUTH_ACTIONS.editCurrentUser) || {};

  const handleSubmit = (data: IBandUserBodyPreferences) => {
    const cleanData: IBandUserBodyPreferences = merge({}, data, {
      bodyPreferences: {
        smoker: data.bodyPreferences?.smoker === UserBooleanAttribute.yes ? true : false,
      },
    });

    setFormSubmitted(true);
    dispatch(editCurrentUser(cleanData));
  };

  useEffect(() => {
    if (status === IAPIState.succeeded) {
      handleClose();
    }
  }, [handleClose, status]);

  const defaultValues = useMemo(
    () =>
      merge({}, pick(userAttributes, "bodyPreferences"), {
        bodyPreferences: {
          smoker: userAttributes?.bodyPreferences?.smoker
            ? UserBooleanAttribute.yes
            : UserBooleanAttribute.no,
        },
      }),
    [userAttributes]
  );

  const { isFormSubmitted, setFormSubmitted } = useIsUserPreferenceFormSubmitted();

  return (
    <UserBodyPreferencesForm
      defaultValues={defaultValues}
      handleSubmit={handleSubmit}
      apiError={isFormSubmitted ? error : undefined}
      error={isFormSubmitted ? !!error : undefined}
      apiStatus={isFormSubmitted ? status : undefined}
    />
  );
};
